import { useParams } from "react-router-dom";
import {
  ProcurementDetailsPageHeader,
  ProcurementDetailsTable,
  ProcurementDetailsForm,
} from "./components";
import { useAnnualProcurementPlan } from "@hooks/procurements/annualProcurementPlan/useAnnualProcurementPlan";
import { useRemainingAppTotalBudget } from "@hooks/procurements/annualProcurementPlan/useRemainingAppTotalBudget";

export default function AnnualProcurementPlanDetails() {
  const { id } = useParams();
  const { annualProcurementPlanState } = useAnnualProcurementPlan(id as string);

  const { getSingleData } = annualProcurementPlanState;
  const appTotalBudget = getSingleData?.budget;
  const appTotalPackageBudget = getSingleData?.totalPackageBudget;

  const { remainingAppTotalBudget } = useRemainingAppTotalBudget({
    appTotalBudget,
    appTotalPackageBudget,
  });
  //!!! used any

  return (
    <div className="d-grid gap-10 p-10">
      <ProcurementDetailsPageHeader data={id ? (getSingleData as any) : null} />
      <ProcurementDetailsForm
        procurement={id ? (getSingleData as any) : null}
        id={id as string}
        remainingAppTotalBudget={remainingAppTotalBudget}
      />
      <ProcurementDetailsTable
        id={id as string}
        remainingAppTotalBudget={remainingAppTotalBudget}
      />
    </div>
  );
}
